import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import './../theme/index.css'
import BaiduMap from 'vue-baidu-map'

Vue.config.productionTip = false
Vue.use(BaiduMap, { ak: 'moi7p2XAwzXC7CDTlznNfWzcUAKb6Tbn' })
Vue.use(ElementUI)
Vue.prototype.$message = ElementUI.Message

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
